export const InvestorAccountStatus = {
    pending: "Pending",
    active: "Active"
}